export default "__VITE_ASSET__DGCxka5$__"